module.exports = __webpack_public_path__ + "img/inquiry.25927acf.png";